import React from 'react';

const ChevronRight = (props) => {
  const {
    fill = 'currentColor',
    className,
  } = props;

  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
      <path className="arrow-right" fill={fill} fillRule="evenodd" d="M8.6 7.4L10 6l6 6-6 6-1.4-1.4 4.6-4.6z" />
    </svg>
  );

};

export default ChevronRight;
